package org.moxultimate.topwithmox.wallpapercrud.main

import androidx.compose.runtime.Immutable
import org.moxultimate.topwithmox.wallpaper.data.WallpaperResponse

/** State for upload/update operations (add, edit). */
@Immutable
sealed class WallpaperCRUDState {
    data object Idle : WallpaperCRUDState()
    data object Loading : WallpaperCRUDState()
    data class Success(val message: String) : WallpaperCRUDState()
    data class Error(
        val message: String,
        /** HTTP status code returned by the server, or 0 for network/read errors. */
        val statusCode: Int = 0,
        /** 0-based index of the entry that caused the failure; null for non-batch errors. */
        val failedEntryIndex: Int? = null,
    ) : WallpaperCRUDState()
}

/** State for the wallpaper list shown in WallpaperCRUDPage. */
@Immutable
sealed class WallpaperListState {
    data object Loading : WallpaperListState()
    data class Success(
        val wallpapers: List<WallpaperResponse>,
        val typeList: List<String>,
        val hasMore: Boolean = true,
    ) : WallpaperListState()
    data class Error(val message: String, val statusCode: Int = 0) : WallpaperListState()
}
